import { Injectable, inject } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { IManageEntityRoutes, SafeAny } from '@pf/shared-common';
import { map, of } from 'rxjs';
import {
    LaneCarrierCreate,
    LaneCarrierDataService,
    LaneCarrierDto,
    LaneCarrierMapper,
    LaneCarrierRead,
    LaneCarrierSearchParams,
    LaneCarrierStore,
} from '@pf/platform-loads/domain';
import { LaneCarrierViewModelCreateBody } from '@control-tower/platform-loads';

@Injectable()
export class LaneCarrierFacade extends AbstractManageEntityFacade<
    LaneCarrierDto,
    LaneCarrierRead,
    LaneCarrierCreate,
    LaneCarrierSearchParams
> {
    nameField: keyof LaneCarrierDto = 'name';

    constructor() {
        const dataService = inject(LaneCarrierDataService);
        const store = inject(LaneCarrierStore);
        const mapper = inject(LaneCarrierMapper);

        super(
            dataService,
            null as unknown as IManageEntityRoutes,
            store,
            mapper
        );
    }

    override add() {
        this.store.resetActiveEntity();
    }

    override manage() {
        this.store.resetActiveEntity();
    }

    override edit(entityId: string): void {
        this.store.setActiveEntity(entityId);
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField as SafeAny
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof LaneCarrierDto, string>> {
        return { name: searchText };
    }

    checkIfLaneCarrierExists(dto: LaneCarrierDto) {
        return dto.id
            ? of(false)
            : this.oneTimeSearch$({
                  pageSize: 1,
                  pageIndex: 1,
                  filters: {
                      laneId: dto.laneId as string,
                      name: dto.name as string,
                  },
              }).pipe(map(result => result.totalRecords > 0));
    }

    override applyResourceAuth(body: LaneCarrierViewModelCreateBody): void {
        body.resourceAuth = { allAuthorized: true };
    }
}
